function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "m1374 3480c682-233 1892-1412 2111-2127l64 89c416 684 509 841 1140 1422 494 455 619 413 949 645-839 463-1745 1240-2126 2137-74-84-140-228-208-332-384-594-706-979-1280-1399l-633-418c-3-11-12-11-17-17zm-1343 7c40 46 804 479 1057 675l942 813c374 386 864 1008 1148 1472 85 138 251 465 334 553 416-898 714-1169 1240-1785 307-359 764-733 1158-1031l1059-693c-967-369-2155-1506-2801-2411-127-177-227-321-348-515l-321-548c-3-4-10-12-15-17-166 530-995 1609-1428 2029-277 269-597 528-940 787-237 180-772 539-1085 671z"
});

var SvgColorless = function SvgColorless(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 7000 7000",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgColorless, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/colorless.10246fb4.svg";
export { ForwardRef as ReactComponent };